const getToken = () => localStorage.getItem("token-jwt") || "";

const getCustomerID = () => localStorage.getItem("customerId") || "";

const getUserEmail = () => localStorage.getItem("customerEmail") || "";

const setToken = (token) => localStorage.setItem("token-jwt", token);

export { getToken, setToken, getCustomerID, getUserEmail };
